import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import * as React from "react";

export default function MPPTTrackingSelect({ value, onChange, disabled = false }) {
  return (
    <FormControl fullWidth>
      <InputLabel>MPPT tracking mode</InputLabel>
      <Select
        value={value}
        label="MPPT tracking mode"
        disabled={disabled}
        onChange={(event) => {
          onChange(event);
        }}
      >
        <MenuItem key={0} value={0}>
          GRID
        </MenuItem>
        <MenuItem key={1} value={1}>
          INTERNAL
        </MenuItem>
        <MenuItem key={100} value={100}>
          DISABLED
        </MenuItem>
      </Select>
    </FormControl>
  );
}
